let ERRORS_TAB = {
  options: {
    tabName: 'errors',
    uri: '/batches/last/sourceErrors'
  },
  columns: [{
    name: 'text',
    label: 'Issue',
    formatFilter: 'uppercase',
    type: 'table-grid-text-cell'
  }, {
    name: 'name',
    label: 'File Type  ',
    formatFilter: 'uppercase',
    type: 'table-grid-text-cell'
  }, {
    name: 'errorCount',
    label: 'Instances',
    type: 'table-grid-text-cell'
  }, {
    name: 'level',
    label: 'Severity',
    map: {
      1: 'error-severity-1',
      2: 'error-severity-2',
      3: 'error-severity-3',
    },
    type: 'table-grid-icon-cell'
  }]
};

export
default ERRORS_TAB;



// WEBPACK FOOTER //
// ./app/models/errorsTab.js